

















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { MedicationUse } from '@/data-service/types';

@Component
export default class MedicationDisplay extends Vue {
  @Prop({ required: true }) medicationUse!: MedicationUse;
}
